"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = require("@Components/Buttons/Button");
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const react_1 = __importDefault(require("react"));
const bulk_error_strings_1 = __importDefault(require("@Components/Popups/BulkUploadErrorPopup/bulk-error-strings"));
require("./index.scss");
const BulkUploadErrorPopup = (props) => {
    var _a;
    const errorText = bulk_error_strings_1.default[props.modalErrorType];
    const errorBody = (_a = props.modalErrorMessage) !== null && _a !== void 0 ? _a : errorText.errorBody;
    return (react_1.default.createElement(Popup_1.default, { onClose: props.onClose, showClose: false },
        react_1.default.createElement("div", { className: 'documents-container' },
            react_1.default.createElement("div", { className: 'info-head' },
                react_1.default.createElement("h3", null, errorText.header),
                react_1.default.createElement("p", { className: "bold" }, errorText.subheader),
                errorBody && react_1.default.createElement("p", null, errorBody),
                react_1.default.createElement("p", null, errorText.footer)),
            react_1.default.createElement("div", { className: "search-confirm-popup-content" },
                react_1.default.createElement("div", { className: 'buttons-block' },
                    react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: props.onClose }, "OK"))))));
};
exports.default = BulkUploadErrorPopup;
